import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-gtag";
import { EuiSpacer } from "@elastic/eui";
import DangerBox from "components/Outdoor_Cameras/IN-9408_WQHD/Camera_Reset/DangerBox";
import PrimaryBox from "components/Outdoor_Cameras/IN-9408_WQHD/Camera_Reset/PrimaryBox";
import NavButtons from "components/Outdoor_Cameras/IN-9408_WQHD/NavButtons";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  DangerBox,
  PrimaryBox,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};